<div class="container mx-auto px-4">
  <div class="sticky-report-header sticky z-40 bg-white pt-2 pb-6 border-b border-gray-200" style="top: 64px;">
    <!-- Header Section -->
    <div class="mb-6">
      <h1 class="text-3xl font-bold text-gray-800 mb-2">
        Non Registered Clients Report
      </h1>
      <p class="text-gray-600">
        Comprehensive invoice report for all non-registered clients, including
        archived records. Archived clients are tagged in the table.
      </p>
    </div>

    <!-- Filters and Actions -->
    <search class="lg:w-full mt-4" tuiSearch style="padding-left: 0">
      <fieldset class="flex items-center gap-4 border-none">
        <!-- Search Filter -->
        <div class="w-[300px]">
          <tui-textfield iconStart="@tui.search">
            <input [formControl]="searchControl" placeholder="Search by name or ref no" tuiTextfield />
          </tui-textfield>
        </div>

        <!-- Range Filter Type -->
        <div class="w-[180px]">
          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="rangeFilterControl"
            class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let type of rangeFilterTypes" [value]="type">
              {{ type }}
            </option>
          </select>
        </div>

        <!-- Monthly Filter (Shown when Monthly is selected) -->
        <div class="flex gap-2" *ngIf="rangeFilterControl.value === 'Monthly'">
          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="monthControl"
            class="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let month of months" [value]="month.value">
              {{ month.label }}
            </option>
          </select>

          <select style="
          width: 100%;
          padding: 13px 40px 13px 15px;
          border-radius: 8px;
          border: 1px solid #e0e4e8;
          background-color: white;
          color: #828ba2;
          font-size: 13px;
          appearance: none; /* Removes the default OS arrow */
          -webkit-appearance: none;
          -moz-appearance: none;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          cursor: pointer;" [formControl]="yearControl"
            class="w-[100px] px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500">
            <option *ngFor="let year of years" [value]="year">
              {{ year }}
            </option>
          </select>
        </div>

        <!-- Custom Range Filter (Shown when Custom Range is selected) -->
        <div class="min-w-[280px]" *ngIf="rangeFilterControl.value === 'Custom Range'">
          <tui-input-date-range [formControl]="customRangeControl">
            Choose date range
            <input placeholder="From - To" tuiTextfieldLegacy />
          </tui-input-date-range>
        </div>

        <button (click)="applyFilters()" appearance="secondary" size="m" tuiButton type="button"
          class="w-full sm:w-auto" style="border: 2px solid #e5e7ea; font-weight: 800">
          Search
        </button>

        <button appearance="flat" iconStart="@tui.rotate-cw" tuiButton type="reset" (click)="clearFilters()">
          Clear
        </button>
        <button tuiButton appearance="primary" size="m" (click)="exportToExcel()"
          [disabled]="filteredData.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline mr-2" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Export to Excel
        </button>
      </fieldset>
    </search>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <tui-loader size="xl" [overlay]="true"></tui-loader>
  </div>

  <!-- Report Table -->
  <div *ngIf="!loading" id="printable-report" class="bg-white rounded-lg shadow-md overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Invoice Date
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Invoice Number
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Client Ref No
            </th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Client Name
            </th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              With Home Nursing
            </th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Without Home Nursing
            </th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Total
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let item of filteredData" class="hover:bg-gray-50 transition-colors"
            [class.bg-amber-50]="item.clientArchived">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.invoiceDate | date : "MM/dd/yyyy" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.invoiceNumber }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
              {{ item.clientRefNo }}
              <app-client-archived-badge [visible]="!!item.clientArchived"></app-client-archived-badge>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ item.clientName }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
              LKR {{ item.shiftCharges | number : "1.2-2" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
              LKR {{ item.additionalCharges | number : "1.2-2" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900 font-semibold">
              LKR {{ item.total | number : "1.2-2" }}
            </td>
          </tr>

          <!-- Totals Row -->
          <tr class="bg-blue-50 font-bold" *ngIf="filteredData.length > 0">
            <td colspan="4" class="px-6 py-4 text-right text-sm text-gray-900">
              TOTALS:
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-blue-700">
              LKR {{ totalShiftCharges | number : "1.2-2" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-blue-700">
              LKR {{ totalAdditionalCharges | number : "1.2-2" }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-right text-blue-700">
              LKR {{ grandTotal | number : "1.2-2" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="filteredData.length === 0" class="text-center py-12 text-gray-500">
      <p class="text-lg">No data found</p>
      <p class="text-sm mt-2">Try adjusting your filters</p>
    </div>
  </div>

  <!-- Summary Cards -->
  <div *ngIf="!loading && filteredData.length > 0" class="mt-6">
    <div class="bg-white rounded-lg shadow-md p-6">
      <h3 class="text-sm font-medium text-gray-500 mb-2">Grand Total</h3>
      <p class="text-2xl font-bold text-orange-600">
        LKR {{ grandTotal | number : "1.2-2" }}
      </p>
    </div>
  </div>
</div>